import { setTimeout } from "timers";

var Highcharts = require('highcharts');

interface highchartscope extends ng.IScope {
    vm: any;
}

var theme = {
   colors: ["rgb(40,163,0)", "rgb(0,122,204)", "rgb(255,0,255)", "rgb(102,0,153)", "rgb(255,0,0)"],
   title: false,
   chart: {
       "backgroundColor": "rgb(45,45,45)",
       "borderColor": "rgb(0,0,0)",
       "marginTop": 35,
       "marginBottom": 135,
       "spacingBottom": 16
   },
   legend: {
       "enabled": true,
       "margin": 30,
       "itemStyle": {
           "color": "#C0C0C0 ",
       },
       "itemHoverStyle": {
           "color": "#C0C0C0 "
       },
       "itemHiddenStyle": {
           "color": "#444444 "
       }
   },
   xAxis: {
       "gridLineColor": "#525252 ",
       "gridLineWidth": 1,
       "labels": {
           "style": {
               "color": "#FFFFFF ",
               "font-size": '34px'
           },
           'y': 36
       },
       "lineColor": "#525252 ",
       "tickColor": "#525252 ",
       "title": {
           "style": {
               "color": "#FFFFFF ",
               "font-size": '26px'
           },
           'y': -26,
           'margin': 20
       }
    },
    yAxis: {
        "gridLineColor": "#525252",
        "gridLineWidth": 1,
        "labels": {
            "style": {
                "color": "#FFFFFF",
                "font-size": '22px'
            },
            "y": 6,
            "lineColor": "#525252",
            "tickColor": "#525252",
            "title": {
                "style": {
                    "color": "#FFFFFF",
                    "font-size": '26px'
                }
            }
        }
    },
    plotOptions: {
        "column": {
            "borderColor": "rgb(0,0,0)",
            "borderWidth": "0"
        },
        "series": {
            "dataLabels": {
                "enabled": false
            }
        }
    }
}

class RoadConditions implements ng.IDirective {
    transclude = true;
    restrict = 'E';
    scope = {
        info: "="
    };
    template = require('./template.roadconditions.html');
    public controller = 'roadConditionsController';
    public controllerAs = 'vm';
    public bindToController = true;

    public link: (scope: highchartscope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller) => void;

    constructor() {
        RoadConditions.prototype.link = (scope: highchartscope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller) => {
            $(document).ready(function () {
                scope.$on("data_ready", function () {

                    Highcharts.setOptions(theme);

                    // workaround to fix incorrect tooltip when the screen is scaled.
                    Highcharts.wrap(Highcharts.Pointer.prototype, 'normalize', function (proceed, event, chartPosition) {
                        var e = proceed.call(this, event, chartPosition);
                        var element = this.chart.container;
                        if (element && element.offsetWidth && element.offsetHeight) {

                            var scaleX = element.getBoundingClientRect().width / element.offsetWidth;
                            var scaleY = element.getBoundingClientRect().height / element.offsetHeight;
                            if (scaleX !== 1) {
                                e.chartX = e.chartX / scaleX;
                            }
                            if (scaleY !== 1) {
                                e.chartY = e.chartY / scaleY;
                            }
                        }
                        return e;
                    });

                    // Create the data series.
                    let seriesData = [];
                    for (let roadConditionType of controller.roadConditionTypes) {
                        seriesData.push({
                            name: roadConditionType,
                            data: controller.roadConditionsList[roadConditionType]
                        });
                    }

                    controller.chart = new Highcharts.Chart({
                        chart: {
                            type: 'column',
                            renderTo: "roadConditions",
                            zoomType: 'xy'
                        },
                        xAxis: {
                            categories: controller.roadConditionsList.district,
                            tickmarkPlacement: 'on',
                            title: {
                                text: 'District'
                            }
                        },
                        yAxis: {
                            floor: 0,
                            max: 100,
                            title: false,
                            labels: {
                                formatter: function () {
                                    return this.value + "%";
                                }
                            }
                        },
                        tooltip: {
                            pointFormat: '{series.name}: {point.percentage:.2f}%<br>',
                            shared: true
                        },
                        plotOptions: {
                            column: {
                                stacking: 'normal'
                            }
                        },
                        series: seriesData,
                        credits: {
                            enabled: false
                        }
                    });

                    // Workaround for the highchart control not rendering the entire container width.
                    setTimeout(() =>
                    {
                        controller.chart.reflow();
                    }, 0);

                });
            });
        }
    };

    public static Factory() {
        var directive = () => {
            return new RoadConditions();
        }
        return directive;
    }
}

export default RoadConditions;



// WEBPACK FOOTER //
// ./src/app/roadconditions/directive.roadconditions.ts